import { onBeforeRouteLeave } from 'vue-router';
import { useUIStore } from '@/store/uiStore';
import { useI18n } from '@/composables/useI18n';

/**
 * Asks for confirmation in our own modal before the route is left while there are
 * unsaved changes. Cancelling (button, X or Escape) keeps the user on the page.
 * @param {() => boolean} isDirty
 */
export function useUnsavedChangesGuard(isDirty) {
  const uiStore = useUIStore();
  const { t } = useI18n();

  onBeforeRouteLeave(() => {
    if (!isDirty()) return true;

    return new Promise((resolve) => {
      let settled = false;
      const settle = (leave) => {
        if (settled) return;
        settled = true;
        resolve(leave);
      };

      const modalId = uiStore.addModal(null, {
        title: t('confirmations.unsaved_changes_title'),
        description: t('confirmations.unsaved_changes'),
        status: 'danger',
        submitText: t('confirmations.unsaved_changes_leave'),
        cancelText: t('confirmations.unsaved_changes_stay'),
        onSubmit: () => {
          settle(true);
          uiStore.closeModal(modalId);
        },
        // Runs for cancel, the X and Escape
        beforeClose: () => {
          settle(false);
          return true;
        },
      });
    });
  });
}
